import InputCalendar from '@components/InputCalendar';

interface DateInputProps {
  values: string[];
  onChange: (values: string[]) => void;
}

export function DateInput({ values, onChange }: DateInputProps) {
  return (
    <InputCalendar
      shouldRenderInsidePortal={true}
      name="query-builder-date"
      value={values[0] ?? null}
      emptyValue={null}
      onChange={(v) => onChange(v ? [String(v)] : [])}
      wrapperClassName="w-full"
      className="bg-white dark:bg-white"
    />
  );
}
